"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const modals_1 = require("../../utils/modals");
const __1 = require("..");
const messageModal_style_1 = __importDefault(require("./messageModal.style"));
const DEFAULT_OK_BTN_LABEL = 'ok';
/**
 * @param content - you can pass simplified markdown
 * - for bold: wrap the text with **
 * - for a line break: add <br>
 * @param title - supports bold only
 */
const MessageModal = ({ classes, title, content, close, okBtn = false, okBtnText = '' }) => {
    const proseContent = react_1.useMemo(() => modals_1.parseModalContent(content), [content]);
    return (jsx_runtime_1.jsxs(__1.Modal, Object.assign({ title: title, closeButtonLabel: "Cancel", handleCollapse: close }, { children: [jsx_runtime_1.jsx(__1.ModalContent, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.modalContent }, { children: proseContent }), void 0) }, void 0),
            okBtn && (jsx_runtime_1.jsx(__1.ModalActions, { children: jsx_runtime_1.jsx(__1.Pushbutton, Object.assign({ onClick: close, dataCy: "ok-button" }, { children: okBtnText || DEFAULT_OK_BTN_LABEL }), void 0) }, void 0))] }), void 0));
};
exports.MessageModal = MessageModal;
exports.default = react_jss_1.default(messageModal_style_1.default)(react_1.memo(exports.MessageModal));
//# sourceMappingURL=index.js.map